import React from "react"
import styled from "@emotion/styled"
import { GatsbyImage } from "gatsby-plugin-image"
import { renderEmoji, getVariantLabelSlug } from '../../helpers/emoji.js'
import CopyEmoji from "./copy_emoji"

export default class VariantSection extends React.PureComponent {
  render() {
    const emoji = this.props.emoji;
    const variant_slug = getVariantLabelSlug(this.props.parent_emoji, emoji);
    const variant_name = `${renderEmoji(emoji.codepoints)} ${emoji.name}`;
    return <Wrapper className="section">
      <div className="section_inner">
        <div id={variant_slug} className="name variant_content">
          <span dangerouslySetInnerHTML={
            { __html: variant_name }
          } />
          {` `}
          <small>
            <a href="#top">top</a>
          </small>
        </div>
        {
          emoji.mainImage && <GatsbyImage image={emoji.mainImage.image.childImageSharp.gatsbyImageData} />  
        }
        <CopyEmoji emoji={emoji} {...this.props}/>
        { emoji.tags && emoji.tags.length > 0 && <div>
        <strong>Keywords:</strong> {emoji.tags.map(w => {
          return w.trim();
        }).join(', ')}
        </div> }
        <div><strong>Codepoints:</strong> { emoji.codepoints }</div>
      </div>
    </Wrapper>
  }
}

const Wrapper = styled("div")`
.name { font-size: 20px; margin: 10px 0 30px; }
.name a { color: #000; }
`
